import { fetchClient } from '@/util/fetchClient';

/**
 * Requests a magic link login email for the given email address.
 *
 * This is a public (unauthenticated) endpoint. It always returns success
 * regardless of whether the email exists or a magic link was sent,
 * to prevent user enumeration.
 */
export async function requestMagicLink(email: string): Promise<void> {
  await fetchClient.POST('/v2/auth/request-magic-link', {
    body: { email },
  });
}
